import { HandleReturnItemChange } from 'components/Orders/Order';
import Flex from 'components/ui/Flex';
import Input from 'components/ui/Input';
import { CellInputRefs } from 'hooks/useKeyboardNavigation';
import { ReturnItem, ReturnOrderLine } from 'returnCenter-api';

import { styled } from 'styled-components';

type CommentCellProps = {
    item: ReturnItem;
    itemId?: number | string;
    orderline?: ReturnOrderLine;
    handleReturnItemChange: HandleReturnItemChange;
    disabled?: boolean;
    rowIndex?: string | number;
    colIndex?: string | number;
    cellInputRefs?: CellInputRefs;
    handleArrowKeyDown: (e: any, orderId: any, rowIndex: any, colIndex: any) => void;
    cellRefPrefix?: string;
};

const CommentCell = ({
    itemId,
    orderline,
    handleReturnItemChange,
    item,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
    cellRefPrefix = '',
    disabled = false,
}: CommentCellProps) => {
    return (
        <Flex column gap="0.5rem" className="comment-wrapper">
            <StyledInput
                disabled={disabled}
                role="rowcell"
                data-row={rowIndex}
                data-row-cell={colIndex}
                data-item-id={itemId}
                fullWidth
                key={itemId}
                ref={(el) => {
                    const key = `${cellRefPrefix}${rowIndex}-${colIndex}`;
                    if (cellInputRefs && cellInputRefs.current) {
                        cellInputRefs.current[key] = el;
                    }
                }}
                rounded
                type="text"
                onChange={(e) => {
                    handleReturnItemChange(
                        orderline?.orderNumber ?? '',
                        orderline?.sku ?? '',
                        orderline?.orderLineNumber ?? '',
                        itemId ?? -1,
                        'comment',
                        e.target.value,
                    );
                }}
                value={item.comment ?? ''}
                tabIndex={0}
                onKeyDown={(e) => handleArrowKeyDown(e, itemId, rowIndex, colIndex)}
                bgColor={disabled ? 'disabled' : undefined}
            />
        </Flex>
    );
};

export default CommentCell;

const StyledInput = styled(Input)<{ underline?: boolean; fullWidth?: boolean; textAlignCenter?: boolean }>`
    width: 100%;
    flex: 1;
    input {
        height: 38px !important;
        width: ${({ fullWidth }) => (fullWidth ? '100% !important;' : '55px !important;')};
        text-align: ${({ textAlignCenter }) => textAlignCenter && 'center;'};
        padding-left: 12px !important;
    }
`;
